// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.question_question-container_JtLqm {
    margin: 0.5rem;
    border: 1px solid var(--ui-black-transparent-default);
    border-radius: 0.5rem;
    border-width: 2px;
    padding: 1rem;
    background: white;
}

.question_question-label__9_6O {
    font-size: 0.75rem;
    font-weight: bold;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: var(--text-primary-default);
    padding-bottom: 0.5rem;
}

.question_question-input_U_xic {
    display: flex; /* Keeps the input from going outside this container */
    position: relative;
}

.question_question-submit-button_eQ86k {
    position: absolute;
    top: calc(0.5rem / 2);

    width: calc(2rem - 0.5rem);
    height: calc(2rem - 0.5rem);

    border: none;
    border-radius: 100%;

    color: white;
    background: var(--looks-secondary);
}

[dir="ltr"] .question_question-submit-button_eQ86k {
    right: calc(0.5rem / 2);
}

[dir="rtl"] .question_question-submit-button_eQ86k {
    left: calc(0.5rem / 2);
}

/* Input overrides: width, font-weight, focus outline and padding */

.question_question-input_U_xic > input {
    width: 100%;
    font-weight: normal;

    /* override dark mode */
    background-color: var(--input-background-default);
    color: var(--text-primary-default);
    border-color: var(--ui-black-transparent-default);
}

[dir="ltr"] .question_question-input_U_xic > input {
    padding: 0 2rem 0 .75rem; /* To make room for the submit button */
}

[dir="rtl"] .question_question-input_U_xic > input {
    padding: 0 .75rem 0 2rem; /* To make room for the submit button */
}

.question_question-input_U_xic > input:focus {
    box-shadow: 0px 0px 0px 3px var(--looks-transparent);
}

.question_question-submit-button-icon_LU9C7 {
    width: calc(2rem - 0.5rem);
    height: calc(2rem - 0.5rem);
    position: relative;
    right: -7px;
    left: -7px;
}
`, "",{"version":3,"sources":["webpack://./src/components/question/question.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,cAAc;IACd,qDAAqD;IACrD,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,2DAA2D;IAC3D,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,aAAa,EAAE,sDAAsD;IACrE,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;;IAErB,0BAA0B;IAC1B,2BAA2B;;IAE3B,YAAY;IACZ,mBAAmB;;IAEnB,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,mEAAmE;;AAEnE;IACI,WAAW;IACX,mBAAmB;;IAEnB,uBAAuB;IACvB,iDAAiD;IACjD,kCAAkC;IAClC,iDAAiD;AACrD;;AAEA;IACI,wBAAwB,EAAE,uCAAuC;AACrE;;AAEA;IACI,wBAAwB,EAAE,uCAAuC;AACrE;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.question-container {\n    margin: 0.5rem;\n    border: 1px solid var(--ui-black-transparent-default);\n    border-radius: 0.5rem;\n    border-width: 2px;\n    padding: 1rem;\n    background: white;\n}\n\n.question-label {\n    font-size: 0.75rem;\n    font-weight: bold;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    color: var(--text-primary-default);\n    padding-bottom: 0.5rem;\n}\n\n.question-input {\n    display: flex; /* Keeps the input from going outside this container */\n    position: relative;\n}\n\n.question-submit-button {\n    position: absolute;\n    top: calc(0.5rem / 2);\n\n    width: calc(2rem - 0.5rem);\n    height: calc(2rem - 0.5rem);\n\n    border: none;\n    border-radius: 100%;\n\n    color: white;\n    background: var(--looks-secondary);\n}\n\n[dir=\"ltr\"] .question-submit-button {\n    right: calc(0.5rem / 2);\n}\n\n[dir=\"rtl\"] .question-submit-button {\n    left: calc(0.5rem / 2);\n}\n\n/* Input overrides: width, font-weight, focus outline and padding */\n\n.question-input > input {\n    width: 100%;\n    font-weight: normal;\n\n    /* override dark mode */\n    background-color: var(--input-background-default);\n    color: var(--text-primary-default);\n    border-color: var(--ui-black-transparent-default);\n}\n\n[dir=\"ltr\"] .question-input > input {\n    padding: 0 2rem 0 .75rem; /* To make room for the submit button */\n}\n\n[dir=\"rtl\"] .question-input > input {\n    padding: 0 .75rem 0 2rem; /* To make room for the submit button */\n}\n\n.question-input > input:focus {\n    box-shadow: 0px 0px 0px 3px var(--looks-transparent);\n}\n\n.question-submit-button-icon {\n    width: calc(2rem - 0.5rem);\n    height: calc(2rem - 0.5rem);\n    position: relative;\n    right: -7px;\n    left: -7px;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `question_question-container_JtLqm`;
export { _1 as "question-container" };
export var questionContainer = `question_question-container_JtLqm`;
var _2 = `question_question-label__9_6O`;
export { _2 as "question-label" };
export var questionLabel = `question_question-label__9_6O`;
var _3 = `question_question-input_U_xic`;
export { _3 as "question-input" };
export var questionInput = `question_question-input_U_xic`;
var _4 = `question_question-submit-button_eQ86k`;
export { _4 as "question-submit-button" };
export var questionSubmitButton = `question_question-submit-button_eQ86k`;
var _5 = `question_question-submit-button-icon_LU9C7`;
export { _5 as "question-submit-button-icon" };
export var questionSubmitButtonIcon = `question_question-submit-button-icon_LU9C7`;
export default ___CSS_LOADER_EXPORT___;
